import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { CaptainPanelComponent } from './components/captain-panel/captain-panel.component';
import { ProfileSettingsComponent } from './components/profile-settings/profile-settings.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'panel', component: CaptainPanelComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileSettingsComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];

